// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// Fronteira de semana
// ============================================================================
//
// PORQUE ISTO NÃO É DECORAÇÃO
//   O art. 4.º, i) do Reg. (CE) 561/2006 define a semana como **fixa, de segunda
//   00:00 a domingo 24:00**. Todos os contadores semanais de condução se reiniciam
//   nessa fronteira. Um planeador que não a veja não consegue prever quando um
//   motorista «ganha horas» outra vez.
//
//   A folha actual não a marca — marca apenas os fins de semana em amarelo (V1,
//   medido em 22 colunas). A linha da segunda-feira é acrescento nosso, e a razão
//   é legal, não estética.
// ============================================================================

/**
 * Que dias são segunda-feira, derivado do vector de fins de semana.
 *
 * Derivado em vez de recalculado a partir da data: `fimDeSemana` já vem do
 * servidor e já foi testado. Duas fontes para o mesmo facto é uma a mais.
 *
 * Um dia é segunda-feira quando não é fim de semana e o dia anterior é. O dia 1
 * de Janeiro é caso especial: não tem anterior, e conta como início de semana
 * porque é onde a grelha começa.
 */
export function iniciosDeSemana(fimDeSemana: readonly boolean[]): boolean[] {
  return fimDeSemana.map((fds, i) => {
    if (fds) return false;
    if (i === 0) return true;
    return fimDeSemana[i - 1] === true;
  });
}
